//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

import { Tab, TabItem } from '../../../../components/Tab'
import Slide from '../../../../components/Slide/Slide'
import SlideItem from '../../../../components/Slide/SlideItem'
import Increase from './components/Increase/Increase'
import Clinch from './components/Clinch/Clinch'
import Coins from './components/Coins/Coins.vue'

import { generateDictArrListByKey } from '../../../../utils/dict'

export default {
  name: 'Ranking',
  components: { Tab, TabItem, Slide, SlideItem, Increase, Clinch, Coins },
  data () {
    return {
      tabs: [
        { label: 'home.ranking.increase.title', component: 'Increase', key: 0, value: 0 },
        { label: 'home.ranking.clinch.title', component: 'Clinch', key: 1, value: 1 }
      ],
      currentTab: '1',
      currentTabIndex: 0,
      slideOptions: {
        listenScroll: true,
        probeType: 3,
        directionLockThreshold: 0,
        eventPassthrough: 'vertical'
      }
    }
  },
  computed: {
    ...mapGetters([
      'dict', 'locale'
    ]),
    vcTypeOptions () {
      let excludeKeys = process.env.EXCLUDE_VC_TYPE
      return generateDictArrListByKey(this.dict, 'VcTypeEnum', excludeKeys).map(item => ({...item, component: 'Coins'}))
    }
  },
  watch: {
    locale () {
      this.$nextTick(() => {
        // this.$refs['slide'].refresh()
      })
    }
  },
  methods: {
    clickTabItem (tabItem) {
      this.currentTab = tabItem.value
      this.currentTabIndex = this.vcTypeOptions.findIndex(item => item.value === tabItem.value)
    },
    slideOnChange (current) {
      this.currentTab = this.vcTypeOptions[current].value
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/Ranking/Ranking.vue